import axios from '../../../axios';
import InvoiceTermCondition from '../types/InvoiceTermCondition';

export const url = '/invoicingservice/api/invoice';

export const getAllTermCondition = () => axios.get(`${url}/termconditionlist`);
export const saveTermCondition = (data: InvoiceTermCondition) =>
  axios.post(url + '/create-termcondition', data);

export const updatePaymentVisibilityStatusTerms = (id: string, status: InvoiceTermCondition) =>
  axios.put(`${url}/term-update-visibilityStatus/${id}`, status);
